import * as React from 'react';
import classnames from 'classnames';

import { IPropertyBarProps } from '../type';
import { Style } from '../../../../models/style';

const Min = 1;
const Max = 1000;

const getTextSize = (size: number): number => Math.max(Min, Math.min(Max, size));

const TextProperties = ({ app, onStyleChange }: IPropertyBarProps) => {
  const style = app.get_selection_style() as Style;
  const [textSize, setTextSize] = React.useState(style.text_size.toString());
  React.useEffect(() => {
    setTextSize(style.text_size.toString());
  }, [style.text_size]);
  return (
    <div className="prop-items-group">
      <div className="prop-section-title">Text</div>
      <div className={classnames('prop-item', 'prop-text-size')}>
        <input
          id="text-size"
          type="number"
          title="Text Size"
          aria-label="Text Size"
          min={Min}
          max={Max}
          step={1}
          value={textSize}
          onChange={e => {
            setTextSize(e.target.value);
          }}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              app.update_selection_style({
                text_size: getTextSize(parseInt(textSize, 10)),
              });
              onStyleChange?.();
            }
          }}
          onBlur={() => {
            app.update_selection_style({
              text_size: getTextSize(parseInt(textSize, 10)),
            });
            onStyleChange?.();
          }}
        />
      </div>
      <div className={classnames('prop-item', 'prop-fill-color')}>
        <input
          id="fill-color"
          type="color"
          title="Text Color"
          aria-label="Text Color"
          value={style.fill_color.to_rgb_hex()}
          onChange={e => {
            app.update_selection_style({
              fill_color: e.target.value,
            });
            onStyleChange?.();
          }}
        />
      </div>
    </div>
  );
};

export default TextProperties;
